export enum AreaFilterTypeEnum {
  HEAD_OFFICE = 'HEAD OFFICE',
  DIVISION = 'DIVISION',
  DISTRICT = 'DISTRICT',
  SUB_DISTRICT = 'SUB_DISTRICT',
  UPAZILA = 'UPAZILA',
  UNION = 'UNION',
  WARD = 'WARD',
}
